import { request } from '@/utils/ajax';
import { ObjectHistoryLog, PaginationResult, PaginationRequest, ObjectHistoryLogFilterData } from '@/types';
import { HistoryLogActions } from '@/seller/components/HistoryLog/HistoryLogActions';
import { ObjectHistoryLogObjectType } from '@/seller/components/HistoryLog/HistoryLogObjectType';

export type HistorySearchOptions = HistorySearchFilters & PaginationRequest;
export interface HistorySearchFilters {
    objectType?: ObjectHistoryLogObjectType | null;
    objectIds?: number[];
    groupByIds?: (string | number)[];
    operationKey?: HistoryLogActions['All'][];
    projectId: number;
    residentialUnitIds?: number[];
    performedByUserIds?: number[];
}

export class HistorySearchFilters {
    static empty(projectId: number): HistorySearchFilters {
        return {
            projectId,
            objectType: null,
            objectIds: [],
            groupByIds: [],
            operationKey: [],
            residentialUnitIds: [],
            performedByUserIds: [],
        };
    }
}

export function getHistoryLog(searchOption: HistorySearchOptions): Promise<PaginationResult<ObjectHistoryLog>> {
    return request(`api/object-history`, {
        query: searchOption,
    }).then((x) => x.json());
}

export function getHistoryLogFilterData(searchOption: HistorySearchFilters): Promise<ObjectHistoryLogFilterData> {
    return request(`api/object-history/filter-data`, {
        query: searchOption,
    }).then((x) => x.json());
}
